import PageHeader from '../page-header/PageHeader';

/**
 * @param {object} props
 * @param {import("react").ReactNode} props.customHeader
 * @param {boolean} props.showBack
 * @param {import('react').ReactNode} props.extraButton
 * @param {string} props.titleHeader
 * @returns {import("react").JSX.Element}
 */
function Header({ customHeader, showBack, extraButton, titleHeader, onBack }) {
    return (
        customHeader || (
            <PageHeader showBack={showBack} extraButton={extraButton} titleHeader={titleHeader} onBack={onBack} />
        )
    );
}

export default Header;
